import { useEffect, useRef } from "react";

const ADSENSE_CLIENT = "ca-pub-9544520292600508";

// AdSense display unit. Provide a real `slot` (created in your AdSense dashboard)
// to serve real ads. Until then it shows a labelled placeholder frame.
export const AdSlot = ({ slot, className = "", label = "Publicidad", minHeight = "250px" }) => {
  const ref = useRef(false);

  useEffect(() => {
    if (ref.current || !slot) return;
    ref.current = true;
    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch (e) {
      console.warn("AdSense push error:", e);
    }
  }, [slot]);

  return (
    <div
      className={`w-full border border-white/10 bg-white/[0.02] rounded-md flex items-center justify-center relative overflow-hidden my-6 ${className}`}
      style={{ minHeight }}
      data-testid="ad-slot"
    >
      <span className="absolute top-2 left-2 text-[9px] tracking-[0.25em] uppercase text-zinc-500 font-bold pointer-events-none z-10">
        {label}
      </span>
      {slot ? (
        <ins
          className="adsbygoogle"
          style={{ display: "block", width: "100%", minHeight }}
          data-ad-client={ADSENSE_CLIENT}
          data-ad-slot={slot}
          data-ad-format="auto"
          data-full-width-responsive="true"
        />
      ) : (
        <span className="text-zinc-600 text-xs font-medium tracking-wide">
          Espacio publicitario · Google AdSense
        </span>
      )}
    </div>
  );
};
